import SurveyService from '@/services/SurveyService';
import { encryptStorage } from '@/utils/storage.js';

const survey = {
  namespaced: true,
  state: {
    isLoading: false,
    surveys: [],
  },
  mutations: {
    LOAD_INQUIRIES(state, surveys) {
      state.surveys = surveys;
    },
    TOGGLE_LOADING(state, status) {
      state.isLoading = status;
    },
  },
  actions: {
    async getSurveys({ commit, dispatch }) {
      commit('TOGGLE_LOADING', true);
      const join = encryptStorage.getItem('user').join
      const token =join.token;
      return SurveyService.getSurveys(token)
        .then((response) => {
          if (response.data.length > 0 && response.data[0].length === 3) {
            dispatch('sendSurvey', {
              name: response.data[0][1],
              toggle: true,
            });
            commit('TOGGLE_LOADING', false);
            return 'Sent';
          }
          commit('LOAD_INQUIRIES', response.data);
          commit('TOGGLE_LOADING', false);
          return 'Success';
        })
        .catch((error) => {
          commit('TOGGLE_LOADING', false);
          console.log(error);
        });
    },
    async getSurveysReport({ commit }) {
      const join = encryptStorage.getItem('user').join
      const token = join?.token;
      return SurveyService.getSurveys(token)
        .then((response) => {
          commit('LOAD_INQUIRIES', response.data);
          commit('TOGGLE_LOADING', false);
          return 'Success';
        })
        .catch((error) => {
          commit('TOGGLE_LOADING', false);
          console.log(error);
        });
    },
    async sendSurvey({ commit, dispatch, rootState }, { name, message }) {
      const join = encryptStorage.getItem('user').join
      const userName = encryptStorage.getItem('user').Username;
      const surveyRequested = {
        message: message,
        survey: name,
        agent: userName,
        chatId: rootState.chat.openedChat.destination,
      };
      const openedChat = rootState.chat.openedChat;
      const token = join.token;
      commit('TOGGLE_LOADING', true);
      const isAdmin = join.isAdmin;
      if (isAdmin === false) {
        console.log(rootState.chat.openedChat);
        // userInfo.join.adminUser
        const agentName = join.adminUser || join.userName
        const groupName = 'administrador';
        const finishConversation = false;
        let message = '';
        await dispatch('chat/transferChat', { agentName, groupName, finishConversation, message },{ root: true }) 
      }
      return SurveyService.sendSurvey(token, surveyRequested)
        .then((response) => {
          console.log('sending survey', response);
          const messageData = {
            message: 'Encuesta Enviada',
            chat: openedChat,
            payload: {
              type: 'text',
              text: 'Encuesta Enviada',
            },
          };
          dispatch('conversation/sendSurveyMessage', messageData, {
            root: true,
          });
          // 
          // commit('chat/CLOSE_OPENED_CHATS', null, { root: true });
          // interface
          commit('TOGGLE_LOADING', false);
          // interface
          // if (toggle === false) {
            //   commit('ui/modal/TOGGLE_MODAL', null, { root: true });
            // }
          // new interface
          commit('ui/modal/CLOSE_MODAL', null, { root: true });
          return 'Success';
        })
        .catch((error) => {
          commit('TOGGLE_LOADING', false);
          commit('ui/modal/TOGGLE_MODAL', null, { root: true });
          console.log(error);
        });
    },
  },
};

export default survey;
